<script lang="ts" setup>

import SvgIllustration from '@/vue/atoms/svg-illustration.vue';
import SpinnerTail from '@/vue/atoms/spinner-tail.vue';

defineProps<{
  icon: string,
  active?: boolean,
  padded?: boolean,
  loading?: boolean,
  label?: string, // Optionality caused by legacy reasons. Not visible. Should be always set. TODO: make it mandatory
  useLabelAsTitleAttribute?: boolean;
}>();

defineEmits<{
  click: [],
}>();

</script>
<template>
  <q-btn
    round
    flat
    class="focus-visible"
    :dense="!padded"
    :class="{active}"
    :loading="loading"
    :title="useLabelAsTitleAttribute ? label : null"
    @click="$emit('click')"
  >
    <svg-illustration :name="icon"/>
    <span class="sr-only">{{ label }}</span>
    <template #loading>
      <spinner-tail :size="20"/>
    </template>
  </q-btn>
</template>
<style lang="scss" scoped>
.active {
  background-color: var(--Secondary-secondary-color-1);
}
</style>
